import { render, staticRenderFns } from "./TopConsumerSources.vue?vue&type=template&id=d4fbfebc&scoped=true"
import script from "./TopConsumerSources.vue?vue&type=script&lang=js"
export * from "./TopConsumerSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fbfebc",
  null
  
)

export default component.exports